import { fetchEventSource } from "@microsoft/fetch-event-source"
import { Message } from 'element-ui'
import store from '../store'
import { EventBus } from '@/utils//eventbus.js';

export const STREAM_TIMEOUT_MS = 21 * 60 * 1000 + 30 * 1000
export const GENERATION_STATE_EVENT = 'generation-state-change'

const activeStreams = new Set()

export const getGenerationState = function() {
  const streams = Array.from(activeStreams)
  return {
    active: streams.length > 0,
    stopping: streams.some(stream => stream.stopRequested),
    count: streams.length
  }
}

const publishGenerationState = function() {
  EventBus.$emit(GENERATION_STATE_EVENT, getGenerationState())
}

const stopWorkflow = function(processInstanceId, queueName) {
  const url = process.env.VUE_APP_BASE_API_URL +
    `auth-service/im_messages/stop_workflow/${processInstanceId || 0}`
  return fetch(url, {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + localStorage.lyToken,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ processInstanceId: processInstanceId || 0, queueName })
  }).then(response => {
    if (!response.ok) {
      throw new Error(`stop workflow HTTP ${response.status}`)
    }
    return response.json()
  }).then(result => {
    if (result && result.code !== 0) {
      throw new Error(result.msg || 'stop workflow failed')
    }
    return result
  })
}

export const stopActiveGeneration = function() {
  const streams = Array.from(activeStreams)
  if (streams.length === 0) {
    return Promise.resolve(false)
  }
  return Promise.all(streams.map(stream => stream.requestStop()))
    .then(results => results.some(Boolean))
}

const sse = function(workflowId, params, msgCallback) {
  return new Promise((resolve, reject) => {
    console.log('sse :: workflowId=', workflowId);
    const cb = msgCallback || function() {}
    let startTime = new Date().getTime()
    let msg = ''
    let tips = '糟糕！脑电波链接失败！被神秘信号干扰，请尝试重新生成，或稍后重试！' //失败
    let url = process.env.VUE_APP_BASE_API_URL+`auth-service/im_messages/stream_workflow/${workflowId}`
    params.platformCategory = 'WRITER_WEB'
    const controller = new AbortController()
    let settled = false
    let timeoutId = null
    const stream = {
      processInstanceId: '',
      queueName: '',
      stopRequested: false,
      stopSent: false,
      stopPromise: null,
      stopResolve: null,
      stopReject: null,
      requestStop: null
    }

    if (activeStreams.size === 0) {
      localStorage.removeItem('processInstanceId')
      localStorage.removeItem('queueName')
    }

    const clearStoredMetadata = function() {
      if (localStorage.getItem('processInstanceId') === stream.processInstanceId) {
        localStorage.removeItem('processInstanceId')
      }
      if (localStorage.getItem('queueName') === stream.queueName) {
        localStorage.removeItem('queueName')
      }
    }

    const settle = function(handler, value) {
      if (settled) {
        return
      }
      settled = true
      if (timeoutId) {
        clearTimeout(timeoutId)
      }
      clearStoredMetadata()
      activeStreams.delete(stream)
      publishGenerationState()
      controller.abort()
      if (stream.stopResolve && !stream.stopSent) {
        stream.stopResolve(false)
      }
      handler(value)
    }
    const succeed = function(value) {
      settle(resolve, value)
    }
    const fail = function(reason) {
      const error = reason instanceof Error ? reason : new Error(String(reason))
      // Let feature pages preserve already streamed text when the connection
      // or the final persistence step fails. This is an in-memory draft only;
      // callers must not present it as a confirmed saved version.
      error.partialOutput = msg
      settle(reject, error)
    }
    const metadataValue = function(single) {
      const separator = single.indexOf(':')
      return separator >= 0 ? single.substring(separator + 1) : ''
    }
    const sendStopRequest = function() {
      if (!stream.stopRequested || stream.stopSent || !stream.queueName || settled) {
        return
      }
      stream.stopSent = true
      stopWorkflow(stream.processInstanceId, stream.queueName).then(() => {
        if (stream.stopResolve) {
          stream.stopResolve(true)
        }
      }).catch(error => {
        stream.stopRequested = false
        stream.stopSent = false
        stream.stopPromise = null
        if (stream.stopReject) {
          stream.stopReject(error)
        }
        stream.stopResolve = null
        stream.stopReject = null
        publishGenerationState()
      })
    }
    stream.requestStop = function() {
      if (settled) {
        return Promise.resolve(false)
      }
      if (stream.stopPromise) {
        return stream.stopPromise
      }
      stream.stopRequested = true
      stream.stopPromise = new Promise((stopResolve, stopReject) => {
        stream.stopResolve = stopResolve
        stream.stopReject = stopReject
      })
      publishGenerationState()
      sendStopRequest()
      return stream.stopPromise
    }
    const errorText = function(single) {
      return single.replace(/^ERROR(?::(?:LLM\d+|WORKFLOW)|\d+)?:?/, '')
    }
    const handleStreamError = function(single) {
      single = single.replace(/\\"/g, '"')
      console.error('Received ERROR:', single)
      if (single.startsWith('ERROR2')) {
        store.dispatch('setDialogShowCostomContactFlag', true)
      } else {
        message(errorText(single) || tips)
      }
      if (single.startsWith('ERROR:LLM') || single.startsWith('ERROR:WORKFLOW')) {
        EventBus.$emit('llm-tips', tips)
      }
      // LLM safety/length errors can still have valid partial output. Keep the
      // stream open until AGENT_END so the backend can save and charge it, then
      // let callers refresh the persisted version in their success path.
      if (single.startsWith('ERROR:LLM')) {
        return
      }
      fail(single)
    }

    activeStreams.add(stream)
    publishGenerationState()

    timeoutId = setTimeout(function() {
      message('生成等待超时，已停止本次连接，请稍后重试')
      fail(new Error('workflow stream timeout'))
    }, STREAM_TIMEOUT_MS)

    fetchEventSource(url,
        {
            method: "POST",
            headers: {
                'Authorization': 'Bearer ' + localStorage.lyToken,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(params),
            onmessage: (event) => {
                // console.error('event:', event);
                let updateTime = new Date().getTime()
                let single = event.data.replace(/^"|"$/g, '').replace(/data:/g, '')
                // console.error('Received single:', single);
                single = unicodeToString(single);  // 确保正确处理 \u
                // console.error('Received single:', single);
                if (single.startsWith('ERROR')) {
                    handleStreamError(single)
                }else if (single.startsWith('processInstanceId')) {
                    console.warn('Received processInstanceId:', single);
                    stream.processInstanceId = metadataValue(single)
                    localStorage.setItem("processInstanceId", stream.processInstanceId)
                    sendStopRequest()
                }else if (single.startsWith('AGENT_END_HUMAN')) {
                    console.log('AGENT_END_HUMAN:', single);
                    succeed(msg)
                }else if (single.startsWith('AGENT_END')) {
                    console.log('AGENT_END:', single);
                    succeed(msg)
                }else if (single.startsWith('queueName')) {
                    console.warn('queueName:', single);
                    stream.queueName = metadataValue(single)
                    localStorage.setItem("queueName", stream.queueName)
                    sendStopRequest()
                }else {
                  // console.info("single", single);
                  if(single != ''){
                    msg += single;
                    if(workflowId == '1806516321777786881'){// 标题
                      msg = msg?msg.replace(/\“/g, '“').replace(/\”/g, '”').replace(/\\"/g, '"').replace(/\\n/g, '\n').replace(/\n/g, '<br>'):"";
                    }else{
                      msg = msg?msg.replace(/\“/g, '“').replace(/\”/g, '”').replace(/\\"/g, '"').replace(/\\n/g, '\n'):"";
                    }
                    cb(msg)
                  }
                  if(workflowId != '1806516321777786881'){// 标题
                      let duration = updateTime - startTime
                      handleTips(msg, duration)
                  }
                }
            },
            onerror: (error) => {
                console.info("onerror", error);
                fail(error || new Error('workflow stream error'))
            },
            onopen: (response) => {
                console.info("onopen", response);
                if (!response.ok) {
                  throw new Error(`workflow stream HTTP ${response.status}`)
                }
            },
            onclose: (response) => {
                console.info("onclose", response);
                fail(new Error('workflow stream closed before terminal event'))
            },
            openWhenHidden: true,
            signal: controller.signal
        }
    ).catch(function(error) {
      fail(error)
    })
  })
}
const handleTips = function(msg, duration){
  let temp = msg.replace(/^\s*\n/gm, "").trim()
  let tipsSuccess = '欧吼～脑电波链接成功！正在准备输出' //成功
  if(temp != ''){
    EventBus.$emit('llm-tips', tipsSuccess);
    return false;
  }
  // console.info("duration", duration, msg);
  let tips = ''
  // 60s、提示用户：糟糕！脑电波链接失败！被神秘信号干扰，请尝试重新生成，或稍后重试！ 失败
  // 50S、提示用户：码哩码哩哄～(╯‵□′)╯︵┻━┻（持续念咒中···）
  // 40S、提示用户：码哩码哩哄～(╯°□°）╯︵ ┻━┻（念咒中···）
  // 30S、提示用户：共脑中(●--●)···
  // 20S、提示用户：码哩正在读取你的想法(●°u°●)​ 」···
  // 10S、提示用户：码哩正在打开脑电波，接受信号中O(∩_∩)O~···
  // if(duration > 60*1000){
  //   tips = '糟糕！脑电波链接失败！被神秘信号干扰，请尝试重新生成，或稍后重试！' //失败
  //   tips = '欧吼～脑电波链接成功！正在准备输出···' //成功
  // }
  if(duration > 40*1000){
    tips = '码哩码哩哄～(╯‵□′)╯︵┻━┻（持续念咒中）'
  }else if(duration > 30*1000){
    tips = '码哩码哩哄～(╯°□°）╯︵ ┻━┻（念咒中）'
  }else if(duration > 20*1000){
    tips = '共脑中(●--●)'
  }else if(duration > 10*1000){
    tips = '码哩正在读取你的想法(●°u°●)​ 」'
  }else if(duration > 0){
    tips = '码哩正在打开脑电波，接受信号中O(∩_∩)O~'
  }
  EventBus.$emit('llm-tips', tips);
}
const message = function(msg){
  Message({
    dangerouslyUseHTMLString: true,
    message: msg,
    type: 'error',
    duration: 8 * 1000
  })
}
const unicodeToString = function (unicodeStr) {
        // 使用正则表达式替换并解析
        return unicodeStr.replace(/\\u([0-9a-fA-F]{4})/g, (match, hex) => {
          // 将十六进制值转换为 Unicode 字符
          return String.fromCharCode(parseInt(hex, 16));
        });
      };
export default sse
